import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routes from './routes/appRoutes';
import { GlobalStyle } from './GlobalStyles';

const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <GlobalStyle />
        <Routes />
      </div>
    </Router>
  );
};

export default App;
